import type {
  HotelResultsV2IconName,
  HotelResultsV2QuickFilterKey,
  HotelResultsV2SortValue,
} from "./types";

export const HOTEL_RESULTS_V2_SORT_OPTIONS: Array<{
  value: HotelResultsV2SortValue;
  label: string;
  icon: "Lightning" | "TrendDown" | "TrendUp" | "Star";
}> = [
  { value: "recommended", label: "پیشنهادی", icon: "Lightning" },
  { value: "price_asc", label: "کمترین قیمت", icon: "TrendUp" },
  { value: "price_desc", label: "بیشترین قیمت", icon: "TrendDown" },
  // Kept for when reliable guest score data is available in hotel results.
  // { value: "score_desc", label: "بهترین امتیاز", icon: "Star" },
  { value: "stars_desc", label: "بیشترین ستاره", icon: "Star" },
];

export const HOTEL_RESULTS_V2_QUICK_FILTERS: Array<{
  key: HotelResultsV2QuickFilterKey;
  label: string;
  icon: HotelResultsV2IconName;
  featured?: boolean;
}> = [
  { key: "featured", label: "پیشنهاد ویژه", icon: "Lightning", featured: true },
  { key: "freeCancellation", label: "کنسلی رایگان", icon: "ShieldCheck" },
  { key: "breakfast", label: "صبحانه", icon: "Coffee" },
];

export const HOTEL_RESULTS_V2_SEARCH_ITEMS: Array<{
  icon: "MapPin" | "CalendarBlank" | "Moon" | "Users";
  label: string;
  value: string;
}> = [
  { icon: "MapPin", label: "مقصد", value: "کیش" },
  { icon: "CalendarBlank", label: "تاریخ ورود", value: "۷ خرداد" },
  { icon: "Moon", label: "تعداد شب", value: "۱ شب" },
  { icon: "Users", label: "مسافران", value: "۱ مسافر، ۱ اتاق" },
];
